export const FORMATS = {
  PUBLISH_DATE: "MMM dd, yyyy 'at' h:mmaaa",
} as const;
